'use client';
import { useEffect, useRef } from 'react';
import { pushToDataLayer } from './ga-core';
/**
 * 会員登録フロー用のGAトラッキングコンポーネント
 * 非登録ユーザーの会員登録フローでの離脱率を計測する
 */

export const RegistrationTracker = {
  // 会員登録ボタンクリック時のトラッキング
  trackRegistrationStart: () => {
    pushToDataLayer('registration_start', {
      category: 'user_registration',
      label: 'registration_button_click',
      engagement_value: 1,
    });
  },

  // 外部サイトへの遷移時のトラッキング
  trackExternalRedirect: (callbackUrl: string) => {
    pushToDataLayer('external_redirect', {
      category: 'user_registration',
      label: 'redirect_to_signup_site',
      callback_url: callbackUrl,
      engagement_value: 1,
    });
  },
  // 会員登録完了時のトラッキング（one-time-authページで実行）
  trackRegistrationComplete: () => {
    pushToDataLayer('registration_complete', {
      category: 'user_registration',
      label: 'registration_success',
      engagement_value: 1,
    });
  },
};
/**
 * 会員登録フロー開始時のトラッキング用コンポーネント
 */
function SendGARegistrationStart() {
  const sendingRef = useRef(false);

  useEffect(() => {
    if (sendingRef.current) return;
    sendingRef.current = true;
    RegistrationTracker.trackRegistrationStart();
  }, []);

  return <></>;
}
/**
 * 会員登録完了時のトラッキング用コンポーネント
 */
function SendGARegistrationComplete() {
  const sendingRef = useRef(false);

  useEffect(() => {
    if (sendingRef.current) return;
    sendingRef.current = true;
    RegistrationTracker.trackRegistrationComplete();
  }, []);

  return <></>;
}

export { SendGARegistrationStart, SendGARegistrationComplete };
